import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetSupplierRequestLogs(params) {
  const res = await api.get(routes.GET_SUPPLIER_REQUEST_LOGS, {
    params: params,
  });

  return res;
}
